import { render, staticRenderFns } from "./TaskAssignModal.vue?vue&type=template&id=17f352dd&scoped=true&"
import script from "./TaskAssignModal.vue?vue&type=script&lang=js&"
export * from "./TaskAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskAssignModal.vue?vue&type=style&index=0&id=17f352dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f352dd",
  null
  
)

export default component.exports